import i18n from '@/utils/i18n';
import React from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';

interface Props {
  disabled?: boolean;
  onPress: () => void;
}

export const PricingUndoButton: React.FC<Props> = ({ disabled, onPress }) => {
  const [styles] = useStyles();

  return (
    <Button
      accessibilityLabel={i18n.t('undo')}
      disabled={disabled}
      onPress={onPress}
      size={ButtonSize.Small}
      style={styles.button}
      variant={ButtonVariant.Secondary}
    >
      {i18n.t('undo')}
    </Button>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
